(() => {
  const textOf = (node) => (node?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const hideByText = () => {
    document.querySelectorAll('body *').forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      const text = textOf(node);
      if (!text) return;

      if (text.includes('powered by track123')) {
        node.classList.add('aurum-track123-hidden');
      }

      if (text.includes('your products are reserved') || (text.includes('reserved for') && text.includes('minutes'))) {
        const container = node.closest('div, section, aside, cart-drawer-component') || node;
        container.classList.add('aurum-cart-timer-hidden');
      }

      if (text.includes('have an account') && text.includes('log in') && text.includes('check out faster')) {
        const container = node.closest('p, div, section') || node;
        container.classList.add('aurum-app-hidden');
      }
    });
  };

  const addProductTrust = () => {
    if (!document.querySelector('main[data-template*="product"]')) return;
    if (document.querySelector('.aurum-product-trust')) return;

    const anchor = document.querySelector('.shopify-payment-button') || document.querySelector('product-form') || document.querySelector('form[action*="/cart/add"]');
    if (!anchor) return;

    const trust = document.createElement('div');
    trust.className = 'aurum-product-trust';
    trust.innerHTML = `
      <div class="aurum-product-trust__item">Free shipping on all orders</div>
      <div class="aurum-product-trust__item">Secure debit or credit card checkout</div>
      <div class="aurum-product-trust__item">Easy returns within 14 days</div>
      <div class="aurum-product-trust__item">Support that is always here to help</div>
    `;

    const guide = document.createElement('details');
    guide.className = 'aurum-size-guide';
    guide.innerHTML = `
      <summary>Size guide</summary>
      <p>Not sure about your size? Wrap a thin strip of paper around your finger or wrist, mark where it overlaps, then measure the length in millimeters.</p>
      <ul>
        <li>Ring US 6: approx. 16.5 mm inner diameter</li>
        <li>Ring US 7: approx. 17.3 mm inner diameter</li>
        <li>Ring US 8: approx. 18.2 mm inner diameter</li>
      </ul>
      <p>For bracelets, measure your wrist and add 1-2 cm depending on how relaxed you like the fit.</p>
    `;

    anchor.insertAdjacentElement('afterend', guide);
    anchor.insertAdjacentElement('afterend', trust);
  };

  const improveAboutPage = () => {
    const main = document.querySelector('main[data-template*="page.about-us"]');
    if (!main || main.dataset.aurumAboutFixed === 'true') return;
    main.dataset.aurumAboutFixed = 'true';

    const headings = Array.from(main.querySelectorAll('h1,h2,h3,p')).filter((node) => textOf(node) === 'about us');
    if (headings.length > 1) {
      headings.slice(0, -1).forEach((node) => node.classList.add('aurum-app-hidden'));
    }

    const firstLargeHeading = main.querySelector('h1, h2');
    if (firstLargeHeading && !document.querySelector('.aurum-about-story')) {
      const story = document.createElement('section');
      story.className = 'aurum-about-story';
      story.innerHTML = `
        <h2>Jewelry for the moments that stay with you</h2>
        <p>Aurum&Co was created for people who see jewelry as more than an accessory. A ring, bracelet or necklace can mark a memory, a promise, a celebration or a new chapter.</p>
        <p>We select timeless pieces designed for everyday wear: refined silhouettes, warm gold tones and details that feel personal without being loud.</p>
      `;
      firstLargeHeading.insertAdjacentElement('afterend', story);
    }
  };

  const addFooterMessage = () => {
    const footer = document.querySelector('footer');
    if (!footer || footer.querySelector('.aurum-footer-message')) return;

    const target = footer.querySelector('.footer-content') || footer;
    const block = document.createElement('div');
    block.className = 'aurum-footer-message';
    block.innerHTML = `
      <strong>We are always here for you</strong>
      <p>Questions about sizing, delivery or your order? Contact us anytime.</p>
      <p>Email: support@aurumco.store</p>
      <p>Company phone and legal address should be added before publishing this theme.</p>
    `;
    target.appendChild(block);
  };

  const run = () => {
    hideByText();
    addProductTrust();
    improveAboutPage();
    addFooterMessage();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
